import React, { useState } from "react";
import LicensesDetailsTable from "./LicensesDetailsTable";
import { FormattedMessage, useIntl } from "react-intl";
import { Collapse } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatDate } from "../../Utilities/dateUtils";

const LicensesWithoutAutoRenew = (props) => {
  const intl = useIntl();
  const [collapsed, setCollapsed] = useState(true);
  let rows = [];

  (props.schools ?? []).forEach((school) => {
    (school.programLicenses ?? [])
      .filter((license) => !license.autoRenew)
      .forEach((license) => {
        rows.push({
          id: school.id + "-" + license.id,
          parentId: null,
          licenseName: license.name,
          customerNumber: school.fortKnoxCustomerNumber,
          name: props.onSchoolClick ? (
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                props.onSchoolClick(school, license);
              }}
            >
              {school.name}
            </a>
          ) : (
            school.name
          ),
          address: school.adress.street,
          postalNumber: school.adress.zipCode,
          city: school.adress.city,
          validTo: license.validTo,
          licenseExpiringAt: formatDate(license.validTo, "yyyy-MM-dd"),
          autoRenew: intl.formatMessage({
            id: license.autoRenew ? "Yes" : "No",
          }),
        });
      });
  });

  rows.sort((a, b) => (b.validTo ?? "").localeCompare(a.validTo ?? ""));

  const columns = [
    { name: "licenseName", title: <FormattedMessage id="ProgramLicense" /> },
    { name: "customerNumber", title: <FormattedMessage id="FortnoxNumber" /> },
    { name: "name", title: <FormattedMessage id="Name" /> },
    { name: "address", title: <FormattedMessage id="Address" /> },
    { name: "postalNumber", title: <FormattedMessage id="ZipCode" /> },
    { name: "city", title: <FormattedMessage id="City" /> },
    {
      name: "licenseExpiringAt",
      title: <FormattedMessage id="LicenseExpiringAt" />,
    },
    { name: "autoRenew", title: <FormattedMessage id="AutoRenew" /> },
  ];

  return (
    <div className="container-fluid admin-container">
      <p
        className="h4"
        onClick={() => setCollapsed(!collapsed)}
        style={{ cursor: "pointer" }}
      >
        <FontAwesomeIcon
          style={{ marginRight: ".5em" }}
          className={
            collapsed ? "fa-caret--animated" : "fa-caret--animated collapsed"
          }
          icon="caret-up"
        />
        <FormattedMessage id="LicensesWithoutAutoRenewTitle" />
      </p>
      <Collapse isOpen={!collapsed}>
        <LicensesDetailsTable rows={rows} cols={columns} />
      </Collapse>
    </div>
  );
};

export default LicensesWithoutAutoRenew;
